import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

const ProtectedRoute = () => {
    const { user } = useAuth();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Check if user needs to change password
    if (!user.user?.isPasswordChanged && window.location.pathname !== '/force-password-change') {
        return <Navigate to="/force-password-change" replace />;
    }

    // If password is changed and on force-password-change page, redirect to home
    if (user.user?.isPasswordChanged && window.location.pathname === '/force-password-change') {
        return <Navigate to="/" replace />;
    }

    // Check if company is verified (nested inside user.user)
    const status = user.user?.company?.verificationStatus || 'Pending';
    
    // If not approved, redirect to pending page (if not already there)
    if (status !== 'Approved' && window.location.pathname !== '/pending-verification') {
        return <Navigate to="/pending-verification" replace />;
    }

    // If approved and on pending page, redirect to home
    if (status === 'Approved' && window.location.pathname === '/pending-verification') {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
